// import Home from '@/pages/home'

import React, {lazy} from "react";
import {Navigate} from "react-router-dom";

// import { LazyExoticComponent } from 'react';

// export const LazyImportComponent = (props: {
//   lazyChildren: LazyExoticComponent<() => JSX.Element>;
// }) => {
//   return (
//     <React.Suspense fallback={<div>家在中</div>}>
//       <props.lazyChildren />
//     </React.Suspense>
//   );
// };

// const Home = lazy(() => import('../pages/home/index'))

// const Login = lazy(() => import('../pages/login/index'))

// import Login from '@/pages/login'

// import Home from '@/pages/home/index'
// const Home = lazy(() => import('../page/home/index'));
const routes = [


    {
        id: 'home',
        index: true,
        path: '/home',
        handle: {title: '动态监测', icon: 'iconhome', link: true, isAuth: true},

        element: () => import('@/pages/home')
    },

    {
        id: 'home33',

        path: '/illegal',
        handle: {title: '违规查询', icon: 'iconhome', link: true},
        element: () => import('@/components/layout/Router'),


        children: [
            {
                path: "",
                handle: {hidden: true},
                element: <Navigate replace to='/illegal/query'/>

            },
            {
                id: 'home3',

                path: '/illegal/query',
                handle: {title: '违规查询', hidden: true, icon: 'iconhome', link: true, isAuth: true},
                element: () => import('@/pages/illegal')
            },

            {
                id: 'home4',

                path: '/illegal/detail',
                handle: {title: '违规详情', hidden: true, icon: 'iconhome', link: true, isAuth: true},
                element: () => import('@/pages/illegal-detail')
            },
        ]
    },

    {
        id: 'home2',
        path: '/app-detect',
        handle: {title: '应用检测', icon: 'iconhome', link: true, isAuth: true},
        element: () => import('@/pages/app-detect')
    },
    {
        id: 'home5',
        path: '/pub-opinion',
        handle: {title: '舆情动态', icon: 'iconhome', link: true, isAuth: true},
        element: () => import('@/pages/pub-opinion')
    },
    {
        id: 'home6',
        index: true,
        path: '/disclosure',
        handle: {title: '安天披露', icon: 'iconhome', link: true, isAuth: true},
        element: () => import('@/pages/disclosure')
    },
    {
        id: "login",
        path: "/login",
        handle: {title: "登录", hidden: true, noUseLayout: true},
        element: () => import("@/pages/login"),
    },
    {
        id: "403",
        path: "/403",
        handle: {title: "403", hidden: true, noUseLayout: true},
        element: () => import("@/components/exception/403"),
    },
    {
        id: "404",
        path: "/404",
        handle: {title: "404", hidden: true, noUseLayout: true},
        element: () => import("@/components/exception/404"),
    },
    {
        id: "500",
        path: "/500",
        handle: {title: "500", hidden: true, noUseLayout: true},
        element: () => import("@/components/exception/500"),
    },
];

export const noUseLayoutPaths = routes
    .filter((r) => r.handle?.noUseLayout)
    .map((x) => x.path);
export default routes;
